<p-dialog
    [header]="header()"
    [visible]="visible()"
    (visibleChange)="$event ? null : close()"
    [modal]="true"
    [resizable]="true"
    appendTo="body"
    styleClass="legal-edit-dialog"
    contentStyleClass="!flex !flex-col"
    [style]="{ width: '90rem', maxWidth: '95vw', height: '85vh' }"
>
    <div class="flex-1 min-h-0 grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div class="flex flex-col gap-4 min-h-0">
            <div class="flex flex-col gap-1">
                <label class="font-medium" for="legal-doc-edit-title"
                    >Title</label
                >
                <input
                    pInputText
                    id="legal-doc-edit-title"
                    class="w-full"
                    [ngModel]="title()"
                    (ngModelChange)="title.set($event ?? '')"
                />
            </div>
            <div class="flex flex-col gap-1 flex-1 min-h-0">
                <label class="font-medium">Content</label>
                <div class="flex-1 min-h-40">
                    <p-editor
                        [ngModel]="content()"
                        (ngModelChange)="content.set($event ?? '')"
                    />
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-2 min-h-0">
            <app-legal-template-variables-hint />
            <div class="font-medium">Preview</div>
            <app-legal-doc-view
                class="block flex-1 min-h-0"
                [doc]="{ Title: title(), Content: content() }"
                [fitHeight]="true"
            />
        </div>
    </div>
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (onClick)="close()" />
            <p-button label="Apply" icon="pi pi-check" (onClick)="onApply()" />
        </div>
    </ng-template>
</p-dialog>
